import { SnackbarProvider } from 'notistack';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, GlobalStyles } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { SnackbarUtilsConfigurator } from 'src/utils/snackBarTools';

function snackbarContainerStyles(theme: Theme) {
    return {
        // Chaining classes with themselves to raise specificity above notistack's
        // single-class styles without resorting to `!important`.
        '.snackBarPosition.snackBarPosition': {
            position: 'sticky',
            top: 0,
            left: 0,
            right: 0,
            transform: 'none',
            width: '100vw',
            maxWidth: '100vw',
        },
        '.snackBarPosition.snackBarPosition .notistack-CollapseWrapper': {
            padding: 0,
        },
        '.snackBarPosition .MuiCollapse-root': {
            width: '100vw',
        },
        '.snackBarPosition .notistack-MuiContent': {
            borderRadius: 0,
            padding: `${theme.spacing(1.5)} ${theme.spacing(2.5)}`,
            boxShadow: 'none',
        },
        '.snackBarPosition .notistack-MuiContent-success': {
            backgroundColor: theme.palette.success.main,
        },
        '.snackBarPosition .notistack-MuiContent-error': {
            backgroundColor: theme.palette.error.main,
        },
        '.snackBarPosition .notistack-MuiContent-warning': {
            backgroundColor: theme.palette.warning.main,
        },
        '.snackBarPosition .notistack-MuiContent-info': {
            backgroundColor: theme.palette.grey[200],
            color: theme.palette.grey[900],
        },
        '.snackBarPosition #notistack-snackbar': {
            display: 'flex',
            gap: theme.spacing(1.5),
            padding: 0,
        },
    } as const;
}

const Snackbar = () => (
    <>
        {/* GlobalStyles is used here to apply styles to the snackbar container since notistack does not support sx props */}
        <GlobalStyles styles={(theme) => snackbarContainerStyles(theme)} />
        <SnackbarProvider
            iconVariant={{
                error: <FontAwesomeIcon icon={faExclamationTriangle} />,
                success: <FontAwesomeIcon icon={faCheck} />,
            }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            TransitionComponent={Collapse}
            classes={{
                containerAnchorOriginTopCenter: 'snackBarPosition',
            }}
            maxSnack={1}
        >
            <SnackbarUtilsConfigurator />
        </SnackbarProvider>
    </>
);

export default Snackbar;
